module.exports = __webpack_public_path__ + "static/img/3Vendor-Screening.fa7c5816.gif";